import { render, staticRenderFns } from "./EntradaCompraTableComponent.vue?vue&type=template&id=69569fb7&"
import script from "./EntradaCompraTableComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaCompraTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports